export default "__VITE_ASSET__FOMHx2rP__"